import { Button, LegacyCard, Text } from "@shopify/polaris"
import { CONTACT_TYPES } from "parcelpanel-cross-sell-tracking"
import { useSmartVisibleCrossSellTracker } from "parcelpanel-polling-checker"
import { ProSelectPopover, useMediaQuery, XIcon } from "polaris-enhance"

import APIAPP from "@/api/app"
import { EXPERTSUPPORT_OPTIONS } from "@/constant"
import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import stores from "@/stores"
import { openMiddlewarePage } from "@/utils/location"

export function CrossSellAppBanner() {
  const { UserInfoStore } = stores
  // 关闭新老商家横幅事件
  const handleClose = async () => {
    const res = await APIAPP.closeBanner(7)
    const { code } = res
    if (code === 1000) {
      UserInfoStore.setShowBanner("cross_sell", 2)
    }
  }

  const sm = useMediaQuery("sm")

  const { ref } = useSmartVisibleCrossSellTracker({
    onViewed() {
      window.CrossSellTracker?.logViewed(CROSS_SELL_POINT_ENUM.BannerContact)
    },
    enabled:
      UserInfoStore.showBanner?.cross_sell === 1 &&
      UserInfoStore.data.is_show_cross_sell_banner,
  })

  return (
    <LegacyCard>
      <LegacyCard.Section>
        <div className="flex items-center justify-between">
          <Text variant="headingSm" as="h2">
            {t("YourDedicatedSuccessManagerAwaits")}
          </Text>
          <div>
            <Button icon={XIcon} variant="tertiary" onClick={handleClose} />
          </div>
        </div>
        <div className="flex justify-between gap-4 pr-8 pt-2">
          <div className="flex flex-col">
            <Text variant="bodyMd" as="span">
              {t("YouMightBeMissingOutOnFeaturesTha")}
            </Text>
            <div className="mt-2 flex gap-2" ref={ref}>
              <ProSelectPopover
                value={0}
                onChange={(value) => {
                  const map = {
                    demo: CONTACT_TYPES.DEMO,
                    slack: CONTACT_TYPES.SLACK,
                    whatsapp: CONTACT_TYPES.WHATS_APP,
                    wecom: CONTACT_TYPES.WE_COM,
                  }
                  openMiddlewarePage(
                    CROSS_SELL_POINT_ENUM.BannerContact,
                    map[value],
                  )
                }}
                buttonProps={{
                  variant: "primary",
                  disclosure: true,
                }}
                options={EXPERTSUPPORT_OPTIONS().slice(1, 4)}
                defaultText={t("ContactNow")}
              />
              <Button
                onClick={() => {
                  // 新弹窗页打开
                  const url =
                    "https://calendly.com/channelwill-parcelpanel/parcelpanel"
                  window.open(url, "_blank")
                }}
              >
                {t("BookADemo")}
              </Button>
            </div>
          </div>
          {sm ? (
            <div className="mt-[-26px]">
              <img
                width="100px"
                height="100px"
                src={`/images/book_a_demo.png`}
                alt={"book_a_demo"}
              />
            </div>
          ) : null}
        </div>
      </LegacyCard.Section>
    </LegacyCard>
  )
}
